import { render, staticRenderFns } from "./ChiefDeptRegisterDeepRootView.vue?vue&type=template&id=5dc9ad8b"
import script from "./ChiefDeptRegisterDeepRootView.vue?vue&type=script&lang=js"
export * from "./ChiefDeptRegisterDeepRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports